import { isFeatureEnabled } from 'store/college'
import { useSelector } from 'react-redux'

const useCollegeFeatures = (featureName) => {
  return useSelector((store) => isFeatureEnabled(store, featureName))
}

export default useCollegeFeatures
